module.exports = __webpack_public_path__ + "static/media/archive.84df7fb6.svg";